import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
type message = {
    name: 'login' | 'logout',
    payload?: any,
}
@Injectable({
    providedIn: 'root',
})
export class BroadcastService {
    private bc: BroadcastChannel;
    public receivedLogout$: Observable<void>;
    public receivedLogin$: Observable<string>;
    constructor() {
        this.bc = new BroadcastChannel('app-default');

        const logout$ = new Subject<void>();
        this.receivedLogout$ = logout$.asObservable();

        const login$ = new Subject<string>();
        this.receivedLogin$ = login$.asObservable();

        this.bc.onmessage = (e: MessageEvent<message>) => {
            if (e.data?.name === 'logout') {
                logout$.next();
            } else if (e.data?.name === 'login') {
                login$.next(e.data?.payload);
            }
        };
    }
    public sendLogout() {
        this.send({name: 'logout'});
    }
    private send(msg: message) {
        this.bc.postMessage(msg);
    }
    public sendLogin(token: string) {
        this.send({name: 'login', payload: token});
    }
}
